export { useFeatureFooter } from './use-feature-footer';
